<template>
  <div class="flex gap--5">
    <span v-show="isDoctor" class="only-doc-fill flex">
      <img src="/assets/img/svg/doctor-fill.svg" />
      למילוי ע״י הרופא
    </span>
    <span v-show="isRequired" class="only-doc-fill flex tx--red error--tag">
      * שדה חובה
    </span>
  </div>
</template>

<script>
export default {
  name: "Tags",
  props: {
    isDoctor: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  }
};
</script>
